import { jsx } from "react/jsx-runtime";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import AntTypography from "antd/es/typography";
import classnames from "../../utils/classnames.js";
import useMergeLevelPropByScreen from "./hooks/useMergeLevelPropByScreen.js";
import './Typography.css';/* empty css                */
const Text = ({ level = "main", color = "darkest", className, children, ...props }) => {
  const screen = useBreakpoint();
  const mergedClassLevel = useMergeLevelPropByScreen(level, screen);
  return /* @__PURE__ */ jsx(
    AntTypography.Text,
    {
      className: classnames(
        [
          "perxis-auto-typography",
          "perxis-auto-text",
          `perxis-auto-text--${mergedClassLevel}`,
          `perxis-auto-text--${color}`
        ],
        className
      ),
      ...props,
      children
    }
  );
};
const Paragraph = ({
  level = "main",
  color = "darkest",
  className,
  children,
  ...props
}) => {
  const screen = useBreakpoint();
  const mergedClassLevel = useMergeLevelPropByScreen(level, screen);
  return /* @__PURE__ */ jsx(
    AntTypography.Paragraph,
    {
      className: classnames(
        [
          "perxis-auto-typography",
          "perxis-auto-paragraph",
          `perxis-auto-paragraph--${mergedClassLevel}`,
          `perxis-auto-paragraph--${color}`
        ],
        className
      ),
      ...props,
      children
    }
  );
};
const Link = ({ level = "main", color = "darkest", className, children, ...props }) => {
  const screen = useBreakpoint();
  const mergedClassLevel = useMergeLevelPropByScreen(level, screen);
  return /* @__PURE__ */ jsx(
    AntTypography.Link,
    {
      className: classnames(
        [
          "perxis-auto-typography",
          "perxis-auto-link",
          `perxis-auto-link--${mergedClassLevel}`,
          `perxis-auto-link--${color}`
        ],
        className
      ),
      ...props,
      children
    }
  );
};
const Title = ({
  headingLevel = 1,
  color = "darkest",
  className,
  level = `h${headingLevel}`,
  children,
  ...props
}) => {
  const screen = useBreakpoint();
  const mergedClassLevel = useMergeLevelPropByScreen(level, screen);
  return /* @__PURE__ */ jsx(
    AntTypography.Title,
    {
      level: headingLevel,
      className: classnames(
        [
          "perxis-auto-typography",
          "perxis-auto-title",
          `perxis-auto-title--${mergedClassLevel}`,
          `perxis-auto-title--${color}`
        ],
        className
      ),
      ...props,
      children
    }
  );
};
const Typography = {};
Typography.Text = Text;
Typography.Paragraph = Paragraph;
Typography.Title = Title;
Typography.Link = Link;
export {
  Typography as default
};
//# sourceMappingURL=Typography.js.map
